import { render, staticRenderFns } from "./table_conent.vue?vue&type=template&id=02bbbd09"
import script from "./table_conent.vue?vue&type=script&lang=js"
export * from "./table_conent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bbbd09')) {
      api.createRecord('02bbbd09', component.options)
    } else {
      api.reload('02bbbd09', component.options)
    }
    module.hot.accept("./table_conent.vue?vue&type=template&id=02bbbd09", function () {
      api.rerender('02bbbd09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/order_manage/order_manage_new/form/components/table_conent.vue"
export default component.exports